import axios from 'axios';

// Production: https://globalsampoorna.com/admin/api | Local: http://localhost:8080/api
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
});

api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const apiService = {
  getPages: () => api.get('/public_pages.php'),
  getPage: (slug) => api.get(`/public_pages.php?slug=${slug}`),
  getServices: () => api.get('/public_services.php'),
  getCourses: () => api.get('/public_courses.php'),
  getPlans: (type) => {
    const url = type ? `/public_plans.php?type=${type}` : '/public_plans.php';
    return api.get(url);
  },
  getPlan: (id) => api.get(`/public_plans.php?id=${id}`),
  getNavigation: () => api.get('/public_navigation.php'),
  getSEO: (page) => api.get(`/public_seo.php?page=${page}`),
  getSlider: () => api.get('/public_slider.php'),
  getTestimonials: (featuredOnly = true) =>
    api.get(`/public_testimonials.php${featuredOnly ? '?featured=1' : ''}`),
  submitContact: (data) => api.post('/public_contact.php', data),
  getContactInfo: () => api.get('/public_contact.php?action=info'),
  submitBooking: (data) => api.post('/public_booking.php', data),
  submitPlanEnquiry: (data) =>
    api.post('/public_booking.php', { ...data, type: 'plan_enquiry' }),
  subscribeNewsletter: (email, name = 'Newsletter Subscriber') =>
    api.post('/public_contact.php', {
      name,
      email,
      phone: '',
      service: 'Newsletter',
      message: 'Newsletter subscription from website'
    }),
  getPageSections: (pageIdOrSlug) => {
    const isNumeric = !isNaN(pageIdOrSlug) && !isNaN(parseInt(pageIdOrSlug, 10));
    const param = isNumeric ? `page_id=${pageIdOrSlug}` : `slug=${pageIdOrSlug}`;
    return api.get(`/public_sections.php?${param}`);
  }
};

export default api;
